<template>
  <basic-container>
    <!-- 渠道SDK通用配置管理 -->

    <!-- <el-form :inline="true" :model="params" label-position="right" size="small">
      <el-form-item label="名称">
        <el-input v-model="params.search"></el-input>
      </el-form-item>

      <el-form-item label="配置类别：" style="margin: 0 25px;">
        <el-select clearable v-model="params.templateIds" placeholder="配置类别" multiple>
          <el-option v-for="item in templateList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="渠道：">
        <DynamicOption style="width:200px;" v-model="params.channelIds" />
      </el-form-item>

      <el-form-item label=" ">
        <el-button icon="el-icon-delete" @click="() => { params.channelIds = [], params.templateIds = [] }"
          class="_delete_btn">清空</el-button>
        <el-button icon="el-icon-search" type="primary" @click="getDataList" v-auth="'APPS_CHANNELSDKCONFIG_SEARCH'">
          搜索
        </el-button>
      </el-form-item>

    </el-form> -->

    <!-- <el-button size="small" type="primary" @click="toEdit('')" class="_delete_btn" v-auth="'APPS_CHANNELSDKCONFIG_ADD'">+
      新增</el-button>
    <el-button size="small" type="primary" class="_delete_btn" @click="queryDeatils" v-auth="'APPS_CHANNELSDKCONFIG_ADD'">
      命中配置查询 </el-button> -->
    <avue-crud :option="option" :data="tableData" ref="crud" @refresh-change="refreshChange"
      @sortable-change="sortableChange" :span-method="objectSpanMethod">
      <!-- 自定义搜索框 -->
      <template slot="mySearch">
        <div class="search-contain">
          <div class="search-left">
            <el-input style="width: 200px;" v-model="params.search" placeholder="策略名称"></el-input>
            <el-select filterable style="width: 200px !important; margin-left: 20px;" clearable
              v-model="params.templateIds" placeholder="配置开关" multiple>
              <el-option v-for="item in templateList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
            </el-select>
            <DynamicOption style="width:200px;margin-left: 20px;margin-right: 20px;" v-model="params.channelIds"
              :placeholder="渠道" />
            <el-select style="width: 200px !important;margin-right: 20px;" v-model="params.auditStatus" clearable placeholder="审核状态">
              <el-option v-for="item in [{ label: '草稿', value: 1 }, { label: '待审核', value: 2 }, { label: '审核通过', value: 3 }, { label: '审核不通过', value: 4 }]" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <el-button icon="el-icon-search" type="primary" @click="getDataList" v-auth="'APPS_CHANNELSDKCONFIG_SEARCH'">
              搜索
            </el-button>
            <el-button icon="el-icon-delete"
              @click="() => { params.channelIds = [], params.templateIds = [], params.search = '' }"
              class="_delete_btn">清空</el-button>
          </div>
          <div class="search-left"
            style="width: 500px;position: relative;;margin-top: 20px;margin-bottom: -4vw;z-index: 1 !important;">
            <el-button size="small" type="primary" @click="toEdit()" class="_delete_btn"
              v-auth="'APPS_CHANNELSDKCONFIG_ADD'">+
              新增</el-button>
            <el-button size="small" type="primary" class="_delete_btn" @click="queryDeatils"
              v-auth="'APPS_CHANNELSDKCONFIG_Hit'">
              命中配置查询 </el-button>
          </div>
        </div>
      </template>
      <!-- 自定义表格列 -->
      <template #myIndex="scope">
        <span> {{ scope.row.template && scope.row.template.id }}</span>
      </template>
      <!-- 渠道类型: 1渠道 2平台 -->
      <template #appType="scope">
        <span> {{ scope.row.condition.appType === 1 ? '渠道' : '平台' }}</span>
      </template>
      <template #commonTemplateId="scope">
        <span> {{ scope.row.template && scope.row.template.name }}</span>
      </template>
      <template #appInfo="scope">
        <span> {{ +scope.row.appInfo === 0 ? '全部渠道' : scope.row.appInfo }}</span>
      </template>
      <template #model="scope">
        <div>
          <div>厂商： {{ scope.row.condition && scope.row.condition.manufacturer }} </div>
          <div>品牌： {{ scope.row.condition && scope.row.condition.brand }} </div>
          <div>型号： {{ scope.row.condition && scope.row.condition.model }} </div>
        </div>
      </template>
      <template #uid="scope">
        <div>
          {{ scope.row.condition && scope.row.condition.uid }}
        </div>
      </template>
      <template #uuid="scope">
        <div>
          {{ scope.row.condition && scope.row.condition.uuid }}
        </div>
      </template>
      <template #sdkVersion="scope">
        <div>
          <div>应用版本： {{ scope.row.condition && scope.row.condition.appVersion }} </div>
          <div>SDK版本： {{ scope.row.condition && scope.row.condition.sdkVersion }} </div>
        </div>
      </template>
      <template #myOption="scope">
        <div>
          <el-button type="text" size="small" @click="toCopy(scope.row.id)" v-auth="'APPS_CHANNELSDKCONFIG_COPY'">
            复制
          </el-button>
          <el-button type="text" size="small" @click="toEdit(scope.row.id)" v-auth="'APPS_CHANNELSDKCONFIG_EDIT'" v-if="scope.row.auditStatus != 2">
            编辑
          </el-button>
          <el-button v-if="scope.row.auditStatus === 1 || scope.row.auditStatus === 2 " v-auth="'APPS_CHANNELSDKCONFIG_EDIT'" @click="handleReview(scope.row)" type="text"
          size="small">{{scope.row.auditStatus === 1?'提交审核':'撤销审核'}}</el-button>
          <el-button @click="delItem(scope.row.id)" type="text" size="small" v-auth="'APPS_CHANNELSDKCONFIG_DEL'" v-if="scope.row.auditStatus != 2">
            删除
          </el-button>
        </div>
      </template>
      <!-- 自定义表格操作栏 -->
      <template #menu="scope">
        <el-button v-auth="'APPS_CHANNELSDKCONFIG_LOG'" type="text" size="small" @click="openLog(scope.row.template.id)">
          操作日志
        </el-button>
      </template>
    </avue-crud>
    <!-- <el-table :data="tableData" :span-method="objectSpanMethod" border style="width: 100%; margin-top: 20px">
      <el-table-column prop="commonTemplateId" label="配置类别" width="180">
        <template slot-scope="scope">
          {{ scope.row.template && scope.row.template.name }}
        </template>
      </el-table-column>
      <el-table-column prop="name" label="名称">
      </el-table-column>
      <el-table-column prop="appInfo" label="渠道信息" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ +scope.row.appInfo === 0 ? '全部渠道' : scope.row.appInfo }}
        </template>
      </el-table-column>
      <el-table-column prop="model" label="机型">
        <template slot-scope="scope">
          <div>厂商： {{ scope.row.condition && scope.row.condition.manufacturer }} </div>
          <div>品牌： {{ scope.row.condition && scope.row.condition.brand }} </div>
          <div>型号： {{ scope.row.condition && scope.row.condition.model }} </div>
        </template>
      </el-table-column>
      <el-table-column prop="uid" label="设备">
        <template slot-scope="scope">
          {{ scope.row.condition && scope.row.condition.uid }}
        </template>
      </el-table-column>
      <el-table-column prop="uuid" label="用户配置">
        <template slot-scope="scope">
          {{ scope.row.condition && scope.row.condition.uuid }}
        </template>
      </el-table-column>
      <el-table-column prop="sdkVersion" label="版本">
        <template slot-scope="scope">
          <div>应用版本： {{ scope.row.condition && scope.row.condition.appVersion }} </div>
          <div>SDK版本： {{ scope.row.condition && scope.row.condition.sdkVersion }} </div>
        </template>
      </el-table-column>
      <el-table-column prop="priority" label="优先级">
      </el-table-column>
      <el-table-column prop="dataText" label="值">
      </el-table-column>
      <el-table-column prop="updateTime" label="更新时间">
      </el-table-column>
      <el-table-column prop="address" label="操作">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="toEdit(scope.row.id)" v-auth="'APPS_CHANNELSDKCONFIG_EDIT'">
            编辑
          </el-button>

          <el-button @click="delItem(scope.row.id)" type="text" size="small" v-auth="'APPS_CHANNELSDKCONFIG_DEL'">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table> -->
    <el-pagination style="text-align: right;
  padding: 20px;" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="params.current"
      :page-sizes="[10, 20, 40, 50, 100]" :page-size="params.size" layout="total, sizes, prev, pager, next, jumper"
      :total="params.total">
    </el-pagination>
    <channelSdkConfigEdit v-if="dialogVisible" v-model="dialogVisible" :id="toEditid" :copyId="copyId" @input="handleEditClose" />
    <channelSdkConfigDeatils v-if="dialogVisibleDeatils" v-model="dialogVisibleDeatils" />
    <ChannelSdkConfigLogVue :logVisible.sync="logVisible" :id.sync="logId" />
  </basic-container>
</template>

<script>
import channelSdkConfigEdit from './channelSdkConfigEdit.vue'
import channelSdkConfigDeatils from './channelSdkConfigDeatils.vue'
import ChannelSdkConfigLogVue from './channelSdkConfigLog.vue'
import DynamicOption from '@/components/DynamicOption/index.vue'
import { configCommonPageApi, configCommonTemplateListApi, configCommonDelByIdApi,configCommonReviewApi } from '@/api/channelSdkConfig.js'
import options from "./option";
import { Message } from 'element-ui'
export default {
  components: { DynamicOption, channelSdkConfigEdit, channelSdkConfigDeatils, ChannelSdkConfigLogVue },
  data() {
    return {
      option: options(this),
      dialogVisible: false,
      dialogVisibleDeatils: false,
      toEditid: '',
      copyId: '',
      params: {
        size: 50,
        current: 1,
        ascs: 'commonTemplateId',
        descs: 'priority',
        total: 10,
        templateIds: [],
        channelIds: [],
      },
      templateList: [],
      tableData: [],
      /** 日志对话框的显隐 */
      logVisible: false,
      /** 日志对话框的id */
      logId: 0,
    };
  },
  created() {
    this.getDataList()
    this.getConfigCommonTemplateList()
  },
  methods: {
    // 提交审核
    handleReview (row){
      const obj = {
        auditType: row.auditStatus,
        id:row.id
      }
      configCommonReviewApi(obj).then(()=>{
        this.getDataList()
        Message.success('操作成功')
      })
    },
    /** 处理编辑关闭 */
    handleEditClose() {
      this.getDataList();
      this.copyId = ''
      this.toEditid = ''
    },
    /** 操作日志按钮的事件 */
    openLog(id) {
      this.logVisible = true;
      this.logId = id;
    },
    /** avue刷新控件的方法 */
    async refreshChange() {
      console.log("refreshChange");
      /** 更新数据 */
      await this.getDataList();
    },
    // 查询详情
    queryDeatils() {
      console.log('queryDeatils')
      this.dialogVisibleDeatils = true
    },
    // 获取配置开关
    getConfigCommonTemplateList() {
      configCommonTemplateListApi().then(res => {
        console.log('configCommonTemplateListApi', res)
        this.templateList = res.data || []
      })
    },
    delItem(id) {
      /** 增加二次询问 */
      this.$confirm('此操作将永久删除该配置, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        configCommonDelByIdApi({ id: id }).then(res => {
          console.log(res)
          if (res.status == 200) {
            this.getDataList()
            Message.success('删除成功')
          }
        })
      }).catch(() => {
        // Message.info('已取消删除')
        this.getDataList()
      });


    },
    toCopy(id) {
      this.copyId = id || ''
      this.dialogVisible = true
    },
    toEdit(id) {
      this.toEditid = id || ''
      this.dialogVisible = true
    },
    handleSizeChange(val) {
      this.params.size = val;
      this.getDataList();
    },
    handleCurrentChange(val) {
      this.params.current = val;
      this.getDataList();
    },
    getDataList() {

      const data = { ...this.params }

      data.templateIds = data.templateIds.length ? data.templateIds.join(',') : ''
      data.channelIds = data.channelIds.length ? data.channelIds.join(',') : ''
      console.log('datadatadata', data)

      configCommonPageApi(data).then(res => {
        if (res.status == 200) {
          this.params.total = res.data.total
          this.tableData = res.data.records
        }

        // const startIndex = this.params.current === 1 ? 0 : (this.params.current - 1) * this.params.size
        /** 添加一个属性 */
        this.tableData.forEach((item) => {
          item.myOption = ''
          // const group = this.tableData.filter((i) => item.commonTemplateId === i.commonTemplateId)
          // const indexItem = group.find((i) => typeof i.index === 'number')
          // if (indexItem) {
          //   item.index = indexItem.index
          // } else {
          //   item.index = this.tableData[index - 1] ? this.tableData[index - 1].index + 1 : index
          // }
        });
        console.log('configCommonPageApi', this.tableData)
      })
    },

    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      // console.log('objectSpanMethod', row, column, rowIndex, columnIndex);

      row && column && rowIndex && columnIndex;
      const currentRow = this.tableData[rowIndex];
      if (column.label === 'ID' || column.label === '配置开关' || column.label === '操作') {
        const prevRow = this.tableData[rowIndex - 1];
        if (prevRow && prevRow.commonTemplateId === currentRow.commonTemplateId) {
          return {
            rowspan: 0,
            colspan: 1
          };
        } else {
          let rowspan = 1;
          for (let i = rowIndex + 1; i < this.tableData.length; i++) {
            if (this.tableData[i].commonTemplateId === currentRow.commonTemplateId) {
              rowspan++;
            } else {
              break;
            }
          }
          return {
            rowspan,
            colspan: 1
          };
        }
      }
    }

  }
};
</script>

<style  scoped lang="scss">
.search-left {
  display: flex !important;
  // justify-content: space-between !important;
  align-items: center !important;
}

.avue-crud .avue-input-number,
.avue-crud .el-cascader,
.avue-crud .el-date-editor.el-input,
.avue-crud .el-date-editor.el-input__inner,
.avue-crud .el-select,
.avue-form .avue-input-number,
.avue-form .el-cascader,
.avue-form .el-date-editor.el-input,
.avue-form .el-date-editor.el-input__inner,
.avue-form .el-select {
  width: 70% !important;
}

::v-deep .avue-form__menu--center {
  display: none !important;
}

::v-deep .avue-form__group .el-col-md-6 {
  width: 100%;
}

::v-deep .avue-form__group .el-form-item__content {
  margin-left: 0px !important;
}

::v-deep .avue-crud .avue-crud__search .avue-form .avue-form__group .avue-form__row .el-form-item label {
  float: none;
  display: inline-block;
}
</style>
<style lang="scss">
.el-tooltip__popper{
  max-width: 80%;
}
</style>